import { Token as T } from '@avnu/avnu-sdk';

export const ASSETS = [
  'WBTC',
  'ETH',
  'DAI',
  'USDC.e',
  'USDT',
  'LORDS',
  'wstETH',
  'NSTR',
  'STRK',
  'nstSTRK',
  'xSTRK',
  'sSTRK',
  'EKUBO',
  'UNO',
  'DAIv0',
] as const;
export const BACKEND_ASSETS = [
  'WBTC',
  'ETH',
  'DAI',
  'DAIv1',
  'USDC',
  'USDT',
  'LORDS',
  'WSTETH',
  'NSTR',
  'STRK',
  'nstSTRK',
  'xSTRK',
  'sSTRK',
  'EKUBO',
  'UNO',
] as const;

export type Token = (typeof ASSETS)[number];
export type BackendToken = (typeof BACKEND_ASSETS)[number];
export type AVNUToken = T;
export type PoolToken =
  | 'WBTC'
  | 'ETH'
  | 'USDC.e'
  | 'USDT'
  | 'LORDS'
  | 'STRK'
  | 'BRRR'
  | 'STRONK'
  | 'TONY'
  | 'AKU'
  | 'nstSTRK'
  | 'UNO'
  | 'wstETH'
  | 'DAI'
  | 'PAL'
  | 'zUSDC'
  | 'NSTR'
  | 'DAIv0'
  | 'sSTRK'
  | 'xSTRK';
